import { Component } from '@angular/core';

@Component({
  selector: 'app-my-gpt',
  standalone: true,
  imports: [],
  templateUrl: './my-gpt.component.html',
  styleUrl: './my-gpt.component.scss'
})
export class MyGptComponent {

}
